var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "suggestions", staticClass: "suggestion-list p-2" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "suggestion-loading" },
            [_c("CompassLoader")],
            1
          )
        : _vm.showFakeData
        ? _c(
            "div",
            _vm._l(4, function(n, index) {
              return _c(
                "div",
                {
                  key: n,
                  staticClass: "fake-user",
                  on: {
                    click: function($event) {
                      return _vm.enterHandler(index)
                    }
                  }
                },
                [
                  _c("CompassAvatar", {
                    attrs: {
                      size: "extra-small",
                      photo: "/ressources/logged/img/icon/svg/user.svg"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fake-user__text" }),
                  _vm._v(" "),
                  _c("CompassFeatureBadge", {
                    attrs: { variant: "upsell", size: "small" }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm.items.length > 0
        ? _vm._l(_vm.items, function(staff, index) {
            return _c(
              "div",
              {
                key: staff.id,
                staticClass: "suggestion-list__item p-2 m-0",
                class: { "is-selected": _vm.navigatedStaffsIndex === index },
                on: {
                  mouseover: function($event) {
                    _vm.navigatedStaffsIndex = index
                  },
                  click: function($event) {
                    return _vm.enterHandler(index)
                  }
                }
              },
              [
                _c("avatar-randomized", {
                  staticClass: "mr-1",
                  attrs: {
                    "avatar-image": staff.avatar,
                    firstname: staff.firstname,
                    lastname: staff.lastname,
                    size: "extra-small"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(staff.firstname) + " " + _vm._s(staff.lastname))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "email" }, [
                  _vm._v(" - " + _vm._s(staff.email))
                ])
              ],
              1
            )
          })
        : _c("div", { staticClass: "suggestion-list__item is-empty p-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Aucune correspondance")) +
                "\n    "
            )
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }